import { render, staticRenderFns } from "./FeedbackPopup.vue?vue&type=template&id=e8e0eb22&scoped=true"
import script from "./FeedbackPopup.vue?vue&type=script&lang=ts"
export * from "./FeedbackPopup.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackPopup.vue?vue&type=style&index=0&id=e8e0eb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e0eb22",
  null
  
)

export default component.exports